// extracted by mini-css-extract-plugin
export default {"dots":"Dots_dots__z-vNM","dots__item":"Dots_dots__item__+ATd9","dots__item_current":"Dots_dots__item_current__eGHUr"};